import React from 'react';

export const impressionGlobalData = {
  observer: null,
  impressionMap: new WeakMap(),
  impressed: {},
  impressionRefArray: [],
};

// re-observe items for impressions on visibility change
if (typeof window !== 'undefined') {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('page.visibilitychange', () => {
    if (!document.hidden) {
      impressionGlobalData.impressed = {};
      if (impressionGlobalData.impressionRefArray?.length > 0) {
        for (let i = 0; i < impressionGlobalData.impressionRefArray.length; i += 1) {
          const entry = impressionGlobalData.impressionMap.get(
            impressionGlobalData.impressionRefArray[i]
          );
          // Reset the visibility timer to zero and re-observe each entry
          entry.visibleSince = 0;
          clearTimeout(entry.timeout);
          impressionGlobalData.observer.observe(
            impressionGlobalData.impressionRefArray[i]
          );
        }
      }
    }
  });
}

const defaultContextValue = {
  ref: null,
  clickID: null,
  parent: {
    id: '', // *** required prop ***
    component: '', // *** required prop *** ==> component public export name
    name: 'Page', // *** required prop *** descriptive titles or component name
    variation: '', // cta style values
    position: '',
    type: '',
    category: '',
  },
  data: {
    id: '', // *** required prop ***
    component: '', // *** required prop *** ==> component public export name
    name: 'component', // *** required prop *** ==> descriptive titles or component name
    variation: 'component', // cta style values
    position: '',
    type: '',
    category: '',
  },
  additionalData: {},
};

export const ImpressionContext = React.createContext(defaultContextValue);
